module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAmCAMAAACS/WnbAAAAdVBMVEUAAAAAOD4ANj4ANz0ANj0AOD8AOD8AOD8ANz4ANT4ANz4AJjMAOD8ANT0ANz4ANj4ANDoANz8AOD8ANz4ANj4ANT0ANj0AOTsANz4AOD4ANz8ANj0AOEIAOUIAOTkAOD4AOD8ANz8AOUAAOD4ANz4AMEAAOD+cUoobAAAAJnRSTlMAfzkqJdzu0Lw+bwa/DpV1He+upYd5TBvl0WZcNCwU8eDUtFdGILQzUuUAAAC7SURBVDjLzdLZDoIwFEXRwyiIZZ4RnO//f6LFQqxU8A1cjyc7TW5SvIUXW7BMSBLn5WqiplGGMBZzXGAcE7DkIMQd/HHWeBDZXJlDpp/7MRKB7nGY6kdjCDBn3aDdSxo18GyS1WpgkSxXAjBXYmxzprabqNKPgJEqlAOk1pS/+hXQGYDuCK4tvgQ+VQArKQBudHqogUORh4LIBwK+qEGY9q/fNQZ4QYPBn33arYPcnOOKYMnvIEOgLcnYE37qMYzvTzT/AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/mobile/dingdan.png
// module id = aT9t
// module chunks = 1